import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPw] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const { signIn } = useAuth();
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
      nav('/dashboard');
    } catch (e2) {
      setErr(e2.message ?? 'Sign in failed');
    } finally { setBusy(false); }
  }

  return (
    <div className="container-narrow page-auth">
      <span className="eyebrow">Welcome back</span>
      <h2 className="mt-8 mb-32">Sign in.</h2>
      <div className="card">
        <form onSubmit={onSubmit}>
          {err && <div className="alert error mb-18">{err}</div>}
          <div className="field">
            <label>Email</label>
            <input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPw(e.target.value)} />
          </div>
          <button className="btn btn-primary btn-block" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      <p className="muted center mt-20">
        New here? <Link to="/signup">Create an account</Link>
      </p>
      <p className="muted center mt-8 fs-14">
        <Link to="/forgot-password">Forgot your password?</Link>
      </p>
    </div>
  );
}
